import { value as value_16, map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { singleton as singleton_2, tryFind as tryFind_1, isEmpty, cons, ofArray, empty, filter, map as map_1 } from "../../fable_modules/fable-library.3.7.20/List.js";
import { uncurry, int32ToString, equals, stringHash } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { count, tryFind } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { toString, today, now, compare } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { toString as toString_2, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, class_type, option_type, anonRecord_type, equals as equals_1, record_type, bool_type, list_type, unit_type, int32_type, lambda_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { InvoiceeDetails$reflection, SubscriptionListPhoneNumber$reflection, Contract$reflection } from "../Invoicee/Common.js";
import { Model_GetCurrentNetworkContractNr, Model__GetCurrentContractType_789D039B, Modal, SubscriptionsMsg, Intent, SubscriptionsMsg$reflection, Model$reflection, TerminationOptions, parseTerminateContractAmountRemaining, parseTerminateContractAt, TerminateContractAmountRemaining, TerminateContractAt, TerminationOptions$reflection, ContractTerminationInfo$reflection, formatContractTransferSearchInvoicee, InfoTableViewModel, ClientObject$reflection, InfoTableViewModel$reflection } from "./Model.js";
import { LoadState_map, LoadState_defaultValue, SaveStatus, LoadState$2, getTranslationFrom, Flatpickr_OnChangeOption, LoadState$2$reflection } from "../../Global.js";
import { formatUrl, DateTimeOffsetExtensions_toDate, Locale_get_FromSelectedLanguage, DateOnlyExtensions_toDateTime, doubleToTwoDecimals, DateOnlyExtensions_yyyy_MM_dd, DateOnlyExtensions_fromDateTime, logwi, DateTimeExtensions_toDate, optToStr, Locale$reflection } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { BillingIntervalModule_toInt, Product, ProductModule_ofInt, ProductModule_toTranslation } from "../../DomainTypes.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { RadioInput, RadioInput_get_getDefault, inputRadio, SelectOption, ValueProp, SelectOption_get_getDefault, selectOption, DateOptions, DateOptions_get_getDefault, inputDate } from "../../Components/FormFields/FormFields.js";
import { Placeholder, MinimumDate, Value as Value_4, Locale, FormatDateBy, Id as Id_6, OnChange as OnChange_4 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { DatepickerProps, DatepickerProps_get_getDefault, DatePicker } from "../../Components/StatefulFormFields/Datepicker.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { String30OrEmptyModule_create, String12OrEmptyModule_create, String40OrEmptyModule_create, String32OrEmptyModule_create } from "../../Validation/Common.js";
import { renderEditableSideTable } from "../../Components/Table/Table.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { saveTerminateContract as saveTerminateContract_1, loadTerminateContract as loadTerminateContract_1, changeCancelledDate } from "./Api.js";
import { Prop, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { SearchResult$reflection } from "../../CommonTypes.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { modal, ModalSize, getModalContainer, getModalFooterContainer, getModalHeader } from "../../Components/Modal/Modal.js";
import { DropDownButtonProps, DropDownButtonProps_get_GetDefault, dropDownButton, ButtonProps_get_getDefault, ButtonKind, wrappedButton, modalMain, ButtonProps, defaultProps, modalCancel } from "../../Components/Button/Button.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString as toString_1 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { loadContractsThunk, loadContractTransfersThunk } from "../../Api/Contract.js";
import { MessageKind, customMessage, info as info_6, success, error } from "../../Components/Message/Message.js";
import { fromDateTime } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { dotsLoading, getMaterialIcon } from "../../ViewUtils.js";
import { render as render_2, renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { UTCModule_now, UTC_op_Subtraction_368FF2C0 } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { totalDays } from "../../fable_modules/fable-library.3.7.20/TimeSpan.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { Cmd_OfFunc_result } from "../../fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { ChangeContractModalProps, view } from "../UpdateContractType/View.js";
import { toLocalTime } from "../../fable_modules/fable-library.3.7.20/DateOffset.js";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { DownloadPDFModelProps, view as view_1 } from "../CreateDocumentButton/View.js";
import { DownLoadAndSignProps, view as view_2 } from "./DownloadPDFAndSign.js";
import { SimpleOrderProps, renderSimpleOrder } from "../SimpleOrder/View.js";
import { FeesProps, renderFeesSection } from "../ContractFees/View.js";
import { CreateFeeProps, renderCreateFeeButton } from "../FeesTable/View.js";
import { Cmd_batch } from "../../fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { FeeConfig } from "../../GlobalTypes.js";
import { FeeType, FeeVersion } from "../FeeModal/View.js";
import { BillingInfoProps, renderBillingInfoTable } from "../BillingInfoTable/View.js";
import { saveBillingInfo } from "../BillingInfoTable/Api.js";
import { EndUserTableProps, renderEndUserTable } from "../EndUserTable/View.js";

export function getActivePhoneNumbers(contractNr, numbersMap) {
    return defaultArg(map((numbers) => List_distinct(map_1((nr_1) => nr_1.NumberFrom, filter((nr) => nr.IsActive, numbers)), {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), tryFind(contractNr, numbersMap)), empty());
}

export function $007COngoing$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        if (compare(startDate, now()) < 0) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
    else {
        const endDate = endDateOpt;
        if ((compare(startDate, now()) < 0) && (compare(endDate, now()) > 0)) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
}

export function $007CInFuture$007C_$007C(startDate, endDateOpt) {
    if (compare(startDate, now()) > 0) {
        return startDate;
    }
    else {
        return void 0;
    }
}

export function $007CEnded$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        return void 0;
    }
    else {
        const endDate = endDateOpt;
        if (compare(endDate, now()) < 0) {
            return endDate;
        }
        else {
            return void 0;
        }
    }
}

class RenderContractInfoProps extends Record {
    constructor(GetTranslation, ClientNr, Contract, SaveContractFn, ClientObjectCodes, Locale, ShowObjectCode, ShowCrossReference, IsTelecom, ShowSubscriptionDescription, UsesContractEndUserTable) {
        super();
        this.GetTranslation = GetTranslation;
        this.ClientNr = (ClientNr | 0);
        this.Contract = Contract;
        this.SaveContractFn = SaveContractFn;
        this.ClientObjectCodes = ClientObjectCodes;
        this.Locale = Locale;
        this.ShowObjectCode = ShowObjectCode;
        this.ShowCrossReference = ShowCrossReference;
        this.IsTelecom = IsTelecom;
        this.ShowSubscriptionDescription = ShowSubscriptionDescription;
        this.UsesContractEndUserTable = UsesContractEndUserTable;
    }
}

function RenderContractInfoProps$reflection() {
    return record_type("Containers.Subscriptions.Overview.RenderContractInfoProps", [], RenderContractInfoProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["ClientNr", int32_type], ["Contract", Contract$reflection()], ["SaveContractFn", lambda_type(InfoTableViewModel$reflection(), unit_type)], ["ClientObjectCodes", LoadState$2$reflection(list_type(ClientObject$reflection()), string_type)], ["Locale", Locale$reflection()], ["ShowObjectCode", bool_type], ["ShowCrossReference", bool_type], ["IsTelecom", bool_type], ["ShowSubscriptionDescription", bool_type], ["UsesContractEndUserTable", bool_type]]);
}

const renderContractInfo = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, children_4, children_8, matchValue, inputRecord, children_10, children_12, matchValue_1, inputRecord_1, children_14, children_16, matchValue_3, inputRecord_2, displayValue, matchValue_4, matchValue_5, inputRecord_3, children_22, children_24, matchValue_6, inputRecord_4, children_26, children_28, matchValue_7, inputRecord_5, children_30, children_32, matchValue_8, inputRecord_6;
    const contractTypesLoadState = useSelector((state) => state.Contract.ContractTypes);
    const isEditingState = react.useState(false);
    const isCancelledDateChangeState = react.useState(false);
    const startDateState = react.useState(defaultArg(props.Contract.StartDate, today()));
    const cancelledDateState = react.useState(props.Contract.CancelledDate);
    const endUserState = react.useState(optToStr(props.Contract.EndUser));
    const endUserCategoryState = react.useState(optToStr(props.Contract.EndUserCategory));
    const endUserOrgNrState = react.useState(props.Contract.EndUserOrganizationnr);
    const clientObjectCodeState = react.useState(optToStr(props.Contract.ObjectNumber));
    const clientCrossRefState = react.useState(optToStr(props.Contract.ClientCrossRef));
    react.useEffect(() => {
        isEditingState[1](false);
        isCancelledDateChangeState[1](false);
        startDateState[1](defaultArg(props.Contract.StartDate, today()));
        cancelledDateState[1](props.Contract.CancelledDate);
        endUserState[1](optToStr(props.Contract.EndUser));
        endUserCategoryState[1](optToStr(props.Contract.EndUserCategory));
        endUserOrgNrState[1](props.Contract.EndUserOrganizationnr);
        clientObjectCodeState[1](optToStr(props.Contract.ObjectNumber));
        clientCrossRefState[1](optToStr(props.Contract.ClientCrossRef));
    }, [props.ClientNr, props.Contract.ContractNumber]);
    const header = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Subscriptions");
    const contractTypeOpt = react.useMemo(() => {
        if (contractTypesLoadState.tag === 2) {
            return tryFind(props.Contract.ContractTypeCode, contractTypesLoadState.fields[0]);
        }
        else {
            return void 0;
        }
    }, [props.Contract.ContractTypeCode, contractTypesLoadState]);
    const contractTypeDisplay = defaultArg(map((contractType) => contractType.Display, contractTypeOpt), props.Contract.ContractTypeCode);
    const contractTypeCodeRow = [ofArray([(children = [props.GetTranslation("Common.SubscriptionForm")], react.createElement("span", {
        ["data-translation"]: "Common.SubscriptionForm",
    }, ...children)), react.createElement("span", {
        title: props.Contract.ContractTypeCode,
    }, contractTypeDisplay)]), "subscription-contract-type-code"];
    const product = defaultArg(map((contractType_1) => {
        const translation = ProductModule_toTranslation(props.GetTranslation, ProductModule_ofInt(contractType_1.ProductNr));
        return toText(printf("%s"))(translation);
    }, contractTypeOpt), "-");
    const productRow = [ofArray([(children_4 = [props.GetTranslation("Common.Product")], react.createElement("span", {
        ["data-translation"]: "Common.Product",
    }, ...children_4)), react.createElement("span", {}, product)]), "subscription-product"];
    const startDateRow = [ofArray([(children_8 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.StartDate")], react.createElement("span", {
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.StartDate",
    }, ...children_8)), (matchValue = (isEditingState[0]), matchValue ? inputDate((inputRecord = DateOptions_get_getDefault(), new DateOptions(ofArray([OnChange_4((arg_1) => {
        startDateState[1](arg_1);
    }), Id_6("subscription-start-date-input"), FormatDateBy((date_1) => DateTimeExtensions_toDate(props.Locale.ILocale, date_1)), Locale(props.Locale.FlatpickrLocale), Value_4(startDateState[0])]), inputRecord.LabelText, true, inputRecord.Disabled, inputRecord.OnClearClick))) : ((children_10 = [defaultArg(map((date) => DateTimeExtensions_toDate(props.Locale.ILocale, date), props.Contract.StartDate), "")], react.createElement("span", {}, ...children_10))))]), "subscription-start-date"];
    const endDateRow = [ofArray([(children_12 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndDate")], react.createElement("span", {
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.EndDate",
    }, ...children_12)), (matchValue_1 = (isEditingState[0]), matchValue_1 ? DatePicker((inputRecord_1 = DatepickerProps_get_getDefault(), new DatepickerProps(toList(delay(() => append(singleton(Flatpickr_OnChangeOption((dateOpt) => {
        const isChanged_1 = !equals(cancelledDateState[0], dateOpt);
        isCancelledDateChangeState[1](isChanged_1);
        cancelledDateState[1](dateOpt);
    })), delay(() => append(singleton(Id_6("subscription-end-date-input")), delay(() => append(singleton(FormatDateBy((date_3) => DateTimeExtensions_toDate(props.Locale.ILocale, date_3))), delay(() => append(singleton(Locale(props.Locale.FlatpickrLocale)), delay(() => (((cancelledDateState[0]) != null) ? singleton(Value_4(value_16(cancelledDateState[0]))) : empty_1()))))))))))), inputRecord_1.LabelText, true, inputRecord_1.Disabled, (_arg_10) => {
        const isChanged = !equals(cancelledDateState[0], void 0);
        isCancelledDateChangeState[1](isChanged);
        cancelledDateState[1](void 0);
    }))) : ((children_14 = [defaultArg(map((date_2) => DateTimeExtensions_toDate(props.Locale.ILocale, date_2), props.Contract.CancelledDate), "")], react.createElement("span", {}, ...children_14))))]), "subscription-end-date"];
    let clientObjectCodesOptions;
    const matchValue_2 = props.ClientObjectCodes;
    if (matchValue_2.tag === 2) {
        const options = map_1((objCode) => [int32ToString(objCode.ClientObjectNr), toText(printf("%s (%i)"))(objCode.ObjectDescription)(objCode.ClientObjectNr)], matchValue_2.fields[0]);
        clientObjectCodesOptions = cons(["-1", props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.None")], options);
    }
    else {
        clientObjectCodesOptions = empty();
    }
    const objectCodeRow = [ofArray([(children_16 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Object")], react.createElement("span", {
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.Object",
    }, ...children_16)), (matchValue_3 = ((isEditingState[0]) && (!isEmpty(clientObjectCodesOptions))), matchValue_3 ? selectOption((inputRecord_2 = SelectOption_get_getDefault(), new SelectOption(new ValueProp(0, clientObjectCodeState[0], (e) => {
        const arg_6 = Browser_Types_Event__Event_get_Value(e);
        clientObjectCodeState[1](arg_6);
    }), "subscription-client-object-select", clientObjectCodesOptions, inputRecord_2.Classes, inputRecord_2.LabelText, inputRecord_2.Disabled, inputRecord_2.HTMLProps))) : ((displayValue = defaultArg(map((clientObject) => toText(printf("%s (%i)"))(clientObject.ObjectDescription)(clientObject.ClientObjectNr), (matchValue_4 = props.ClientObjectCodes, (matchValue_4.tag === 3) ? (void 0) : ((matchValue_4.tag === 1) ? (void 0) : ((matchValue_4.tag === 2) ? tryFind_1((obj) => equals(obj.ClientObjectNr, props.Contract.ObjectNumber), matchValue_4.fields[0]) : (void 0))))), optToStr(props.Contract.ObjectNumber)), react.createElement("span", {}, displayValue))))]), "subscription-object-code"];
    const clientCrossRefRow = [ofArray([react.createElement("span", {}, "ClientCrossRef"), (matchValue_5 = (isEditingState[0]), matchValue_5 ? render_1()((inputRecord_3 = TextProps$1_GetDefault(), new TextProps$1(clientCrossRefState[0], inputRecord_3.Type, inputRecord_3.Classes, (e_1) => {
        const arg_7 = Browser_Types_Event__Event_get_Value(e_1);
        clientCrossRefState[1](arg_7);
    }, inputRecord_3.Disabled, inputRecord_3.LabelText, "subscription-client-cross-ref-input", (str) => String32OrEmptyModule_create(props.GetTranslation, str), inputRecord_3.DynamicWidth, inputRecord_3.HTMLProps, inputRecord_3.OnBlur, inputRecord_3.OnFocus, inputRecord_3.AutoComplete, inputRecord_3.Name))) : ((children_22 = [optToStr(props.Contract.ClientCrossRef)], react.createElement("span", {}, ...children_22))))]), "subscription-object-code"];
    const endUserRow = [ofArray([(children_24 = [props.GetTranslation("Common.EndUser")], react.createElement("span", {
        ["data-translation"]: "Common.EndUser",
    }, ...children_24)), (matchValue_6 = (isEditingState[0]), matchValue_6 ? render_1()((inputRecord_4 = TextProps$1_GetDefault(), new TextProps$1(endUserState[0], inputRecord_4.Type, inputRecord_4.Classes, (e_2) => {
        const arg_8 = Browser_Types_Event__Event_get_Value(e_2);
        endUserState[1](arg_8);
    }, inputRecord_4.Disabled, inputRecord_4.LabelText, "subscription-end-user-input", (str_1) => String40OrEmptyModule_create(props.GetTranslation, str_1), inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))) : ((children_26 = [optToStr(props.Contract.EndUser)], react.createElement("span", {}, ...children_26))))]), "subscription-end-user"];
    const endUserCategoryRow = [ofArray([(children_28 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUserCategory")], react.createElement("span", {
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.EndUserCategory",
    }, ...children_28)), (matchValue_7 = (isEditingState[0]), matchValue_7 ? render_1()((inputRecord_5 = TextProps$1_GetDefault(), new TextProps$1(endUserCategoryState[0], inputRecord_5.Type, inputRecord_5.Classes, (e_3) => {
        const arg_9 = Browser_Types_Event__Event_get_Value(e_3);
        endUserCategoryState[1](arg_9);
    }, inputRecord_5.Disabled, inputRecord_5.LabelText, "subscription-end-user-category-input", (str_2) => String12OrEmptyModule_create(props.GetTranslation, str_2), inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name))) : ((children_30 = [optToStr(props.Contract.EndUserCategory)], react.createElement("span", {}, ...children_30))))]), "subscription-end-user-category"];
    const endUserOrgNrRow = [ofArray([(children_32 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUserOrgNr")], react.createElement("span", {
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.EndUserOrgNr",
    }, ...children_32)), (matchValue_8 = (isEditingState[0]), matchValue_8 ? render_1()((inputRecord_6 = TextProps$1_GetDefault(), new TextProps$1(endUserOrgNrState[0], inputRecord_6.Type, inputRecord_6.Classes, (e_4) => {
        const arg_10 = Browser_Types_Event__Event_get_Value(e_4);
        endUserOrgNrState[1](arg_10);
    }, inputRecord_6.Disabled, inputRecord_6.LabelText, "subscription-end-user-orgnr-input", (str_3) => String30OrEmptyModule_create(props.GetTranslation, str_3), inputRecord_6.DynamicWidth, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name))) : react.createElement("span", {}, props.Contract.EndUserOrganizationnr))]), "subscription-end-user-orgnr"];
    const infoEditableTableHtml = renderEditableSideTable(header, toList(delay(() => append(singleton(contractTypeCodeRow), delay(() => append(singleton(productRow), delay(() => append(singleton(startDateRow), delay(() => append(singleton(endDateRow), delay(() => append(((props.IsTelecom ? true : props.ShowSubscriptionDescription) && (!props.UsesContractEndUserTable)) ? singleton(endUserRow) : empty_1(), delay(() => append((props.IsTelecom && (!props.UsesContractEndUserTable)) ? singleton(endUserCategoryRow) : empty_1(), delay(() => append((props.IsTelecom && (!props.UsesContractEndUserTable)) ? singleton(endUserOrgNrRow) : empty_1(), delay(() => append(props.ShowObjectCode ? singleton(objectCodeRow) : empty_1(), delay(() => (props.ShowCrossReference ? singleton(clientCrossRefRow) : empty_1()))))))))))))))))))), isEditingState[0], (_arg_14) => {
        isEditingState[1](true);
    }, (_arg_15) => {
        let a, cancelledDate;
        const infoTableVM = new InfoTableViewModel(startDateState[0], cancelledDateState[0], endUserState[0], endUserCategoryState[0], endUserOrgNrState[0], clientObjectCodeState[0], clientCrossRefState[0]);
        if (isCancelledDateChangeState[0]) {
            startImmediate((a = ((cancelledDate = (cancelledDateState[0]), singleton_1.Delay(() => singleton_1.ReturnFrom(changeCancelledDate(props.ClientNr, props.Contract.ContractNumber, cancelledDate))))), singleton_1.Delay(() => singleton_1.Bind(a, (_arg_16) => singleton_1.Return(void _arg_16)))));
        }
        props.SaveContractFn(infoTableVM);
        isEditingState[1](false);
    }, (_arg_17) => {
        isEditingState[1](false);
    });
    const props_37 = [new HTMLAttr(99, "contract-info-table"), new Prop(0, int32ToString(props.Contract.ContractNumber))];
    return react.createElement("div", keyValueList(props_37, 1), infoEditableTableHtml);
}, "ContractInfo", uncurry(2, void 0), void 0, "renderContractInfo", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\Overview.fs", 398);

export const renderTransferContractWithHistory = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, children_5, children_21;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const transferDate_1 = react.useState(today());
    const searchSelected = react.useState(void 0);
    const errorMessages = react.useState(empty());
    const searchQuery = react.useState("");
    const searchResult = react.useState(empty());
    const complete = react.useState(false);
    const onError_2 = (str_2) => {
        errorMessages[1]((x_3) => cons(str_2, x_3));
    };
    react.useEffect(() => {
        const onError = onError_2;
        const onSuccess = (arg_11) => {
            searchResult[1](arg_11);
        };
        const query = searchQuery[0];
        onSuccess(empty());
        if (query === "") {
        }
        else {
            const _arg = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/invoicee/%i/search?q=%s"))(props.ClientNr)(query)));
            if (_arg.tag === 1) {
                onError("ValidateUrl: " + _arg.fields[0]);
            }
            else {
                startImmediate(singleton_1.Delay(() => {
                    let parseFn, arg_2;
                    return singleton_1.Bind((parseFn = ((arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_1) => {
                        const str = arg_1_1;
                        return equals_1(list_type(SearchResult$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(SearchResult$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
                    })), singleton_1.Delay(() => singleton_1.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(_arg.fields[0])))))), (_arg_1) => {
                        let response_1;
                        return singleton_1.Return((response_1 = _arg_1, (response_1.statusCode === 200) ? (equals_1(list_type(SearchResult$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
                    }))), (_arg_2) => {
                        const _arg_3 = _arg_2;
                        if (_arg_3.tag === 1) {
                            onError("Search: " + _arg_3.fields[0]);
                        }
                        else {
                            onSuccess(_arg_3.fields[0]);
                        }
                        return singleton_1.Return();
                    });
                }));
            }
        }
    }, [searchQuery[0]]);
    const modalHeaderHtml = getModalHeader(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TransferContractNew"), (_arg_8) => {
        props.CloseModal();
    });
    const modalFooterHtml = getModalFooterContainer((children = [modalCancel(new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Cancel"), defaultProps.Content, (_arg_9) => {
        props.CloseModal();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalMain(new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Transfer"), defaultProps.Content, (_arg_10) => {
        const matchValue_4 = searchSelected[0];
        if (matchValue_4 != null) {
            const onError_1 = onError_2;
            const transferDate = transferDate_1[0];
            const current = matchValue_4;
            startImmediate(singleton_1.Delay(() => {
                const _arg_4 = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/contract/%i/%i/transferTo/%i"))(props.ClientNr)(props.ContractNr)(current.InvoiceeNr)));
                if (_arg_4.tag === 1) {
                    onError_1("ValidateUrl: " + _arg_4.fields[0]);
                }
                else {
                    startImmediate(singleton_1.Delay(() => {
                        let record, requestCaseStrategy_1, parseFn_2, arg_8, jsonStr;
                        return singleton_1.Bind((record = {
                            atDate: toString(transferDate, "yyyy-MM-dd"),
                        }, (requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (parseFn_2 = ((arg_8 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_2) => {
                            const str_1 = arg_1_2;
                            return equals_1(anonRecord_type(["contractNr", int32_type]), string_type) ? (new FSharpResult$2(0, str_1)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(anonRecord_type(["contractNr", int32_type]), arg_8, Http_get_ExtraCoders().Value)), str_1);
                        })), (jsonStr = toString_1(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(anonRecord_type(["atDate", string_type])), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record)), singleton_1.Delay(() => {
                            let a;
                            return singleton_1.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(_arg_4.fields[0]))))))), singleton_1.Bind(a, Http_send)), (_arg_5) => {
                                const response_2 = _arg_5;
                                return (response_2.statusCode === 200) ? singleton_1.Return(parseFn_2(response_2.responseText)) : singleton_1.Return(new FSharpResult$2(1, response_2.responseText));
                            });
                        }))))), (_arg_6) => {
                            const _arg_7 = _arg_6;
                            if (_arg_7.tag === 1) {
                                onError_1("Transfer: " + _arg_7.fields[0]);
                            }
                            else {
                                (() => {
                                    complete[1](true);
                                    reduxDispatch(loadContractTransfersThunk(props.ClientNr, props.ContractNr));
                                })();
                            }
                            return singleton_1.Return();
                        });
                    }));
                }
                return singleton_1.Zero();
            }));
        }
        else {
            logwi("[TransferContract] No search result selected.");
            errorMessages[1]((x_4) => cons("No search result selected", x_4));
        }
    }, (searchSelected[0]) == null, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement(react.Fragment, {}, ...children)));
    let modalBodyHtml;
    let searchResulsHtml;
    if (isEmpty(searchResult[0])) {
        searchResulsHtml = react.createElement("div", {});
    }
    else {
        const children_7 = [(children_5 = map_1((searchResult_2) => {
            const children_1 = [formatContractTransferSearchInvoicee(searchResult_2.Name, searchResult_2.InvoiceeNr)];
            return react.createElement("li", {
                className: "search-result__list-item",
                onClick: (_arg_11) => {
                    searchSelected[1](searchResult_2);
                },
            }, ...children_1);
        }, searchResult[0]), react.createElement("ul", {
            className: "search-result__list",
        }, ...children_5))];
        searchResulsHtml = react.createElement("div", {
            className: "contract-transfer__search-result",
        }, ...children_7);
    }
    const children_12 = toList(delay(() => {
        let inputRecord, LabelText;
        return append(singleton(inputDate((inputRecord = DateOptions_get_getDefault(), (LabelText = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TransferDate"), new DateOptions(ofArray([Locale(props.Locale.FlatpickrLocale), MinimumDate(today()), Value_4(transferDate_1[0]), OnChange_4((x_5) => {
            transferDate_1[1](x_5);
        })]), LabelText, true, inputRecord.Disabled, inputRecord.OnClearClick))))), delay(() => {
            let inputRecord_1, LabelText_1, matchValue_5, x_6, matchValue_6, x_7;
            return append(singleton(render_1()((inputRecord_1 = TextProps$1_GetDefault(), (LabelText_1 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.SearchInvoicee"), new TextProps$1((matchValue_5 = (searchSelected[0]), (matchValue_5 == null) ? (searchQuery[0]) : ((x_6 = matchValue_5, formatContractTransferSearchInvoicee(x_6.Name, x_6.InvoiceeNr)))), inputRecord_1.Type, inputRecord_1.Classes, (matchValue_6 = (searchSelected[0]), (matchValue_6 == null) ? ((x_9) => {
                searchQuery[1](Browser_Types_Event__Event_get_Value(x_9));
            }) : ((x_7 = matchValue_6, (x_8) => {
                searchSelected[1](void 0);
                searchQuery[1](Browser_Types_Event__Event_get_Value(x_8));
            }))), inputRecord_1.Disabled, LabelText_1, "transfer-contract-search", inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))))), delay(() => {
                const matchValue_7 = searchSelected[0];
                if (matchValue_7 == null) {
                    return singleton(react.createElement("div", {}, searchResulsHtml));
                }
                else {
                    const x_10 = matchValue_7;
                    return singleton(react.createElement(react.Fragment, {}));
                }
            }));
        }));
    }));
    modalBodyHtml = react.createElement("div", {
        className: "subscriptions__contract-transfer p-4 mb-4",
    }, ...children_12);
    return getModalContainer(new ModalSize(1), (children_21 = toList(delay(() => append(singleton(modalHeaderHtml), delay(() => {
        let children_16;
        return append(singleton((children_16 = map_1((x_11) => {
            const children_14 = [error(x_11.split(""))];
            return react.createElement("div", {}, ...children_14);
        }, errorMessages[0]), react.createElement("div", {}, ...children_16))), delay(() => {
            let children_18;
            return (complete[0]) ? append(singleton((children_18 = [success(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.ContractTransfered").split(""))], react.createElement("div", {
                className: "p-4",
            }, ...children_18))), delay(() => {
                let children_20;
                return singleton(getModalFooterContainer((children_20 = [modalMain(new ButtonProps(getTranslation("Common.Ok"), defaultProps.Content, (_arg_12) => {
                    props.CloseModal();
                }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement(react.Fragment, {}, ...children_20))));
            })) : append(singleton(modalBodyHtml), delay(() => singleton(modalFooterHtml)));
        }));
    })))), react.createElement(react.Fragment, {}, ...children_21)));
}, "TransferContractWithHistory", uncurry(2, void 0), void 0, "renderTransferContractWithHistory", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\Overview.fs", 601);

export class TerminateContractModalProps extends Record {
    constructor(ContractNr, SubscriptionListPhoneNumbers, GetTranslation, Locale, LoadTerminateContract, SaveTerminateContractFn, ConfirmFn, CloseModalFn) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.SubscriptionListPhoneNumbers = SubscriptionListPhoneNumbers;
        this.GetTranslation = GetTranslation;
        this.Locale = Locale;
        this.LoadTerminateContract = LoadTerminateContract;
        this.SaveTerminateContractFn = SaveTerminateContractFn;
        this.ConfirmFn = ConfirmFn;
        this.CloseModalFn = CloseModalFn;
    }
}

export function TerminateContractModalProps$reflection() {
    return record_type("Containers.Subscriptions.Overview.TerminateContractModalProps", [], TerminateContractModalProps, () => [["ContractNr", int32_type], ["SubscriptionListPhoneNumbers", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, list_type(SubscriptionListPhoneNumber$reflection())]), string_type)], ["GetTranslation", lambda_type(string_type, string_type)], ["Locale", Locale$reflection()], ["LoadTerminateContract", lambda_type(class_type("System.DateOnly"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ContractTerminationInfo$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ContractTerminationInfo$reflection()]], [["ErrorValue", string_type]]])]))], ["SaveTerminateContractFn", lambda_type(class_type("System.DateOnly"), lambda_type(TerminationOptions$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["ConfirmFn", lambda_type(unit_type, unit_type)], ["CloseModalFn", lambda_type(unit_type, unit_type)]]);
}

const renderTerminateContractModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_31;
    const contractTerminationInfoState = react.useState(new LoadState$2(0));
    const selectedTerminateContractAtState = react.useState(new TerminateContractAt(1));
    const selectedTerminateContractAmountRemainingState = react.useState(new TerminateContractAmountRemaining(0));
    const selectedTerminationDateState = react.useState(DateOnlyExtensions_fromDateTime(today()));
    const terminateContractStatusState = react.useState(new SaveStatus(0));
    const shouldDeactivateNumbersState = react.useState(true);
    const loadTerminateContract = (date) => {
        contractTerminationInfoState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.LoadTerminateContract(date), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            contractTerminationInfoState[1](arg);
            return singleton_1.Zero();
        })));
    };
    react.useEffect(() => {
        loadTerminateContract(fromDateTime(today()));
    }, []);
    const setTerminateContractAt = (value) => {
        const matchValue = parseTerminateContractAt(value);
        if (matchValue.tag === 1) {
            selectedTerminateContractAtState[1](new TerminateContractAt(1));
            selectedTerminateContractAmountRemainingState[1](new TerminateContractAmountRemaining(0));
            loadTerminateContract(selectedTerminationDateState[0]);
        }
        else {
            selectedTerminateContractAtState[1](new TerminateContractAt(0));
            const matchValue_1 = contractTerminationInfoState[0];
            if (matchValue_1.tag === 2) {
                loadTerminateContract(matchValue_1.fields[0].BoundTo);
            }
        }
    };
    const setTerminateContractAmountRemaining = (value_1) => {
        const arg_4 = parseTerminateContractAmountRemaining(value_1);
        selectedTerminateContractAmountRemainingState[1](arg_4);
    };
    let bodyHtml;
    const matchValue_2 = contractTerminationInfoState[0];
    switch (matchValue_2.tag) {
        case 0: {
            const children = [info_6(props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.WaitingToLoadSubscription").split(""))];
            bodyHtml = react.createElement("div", {
                className: "mt-2",
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.WaitingToLoadSubscription",
            }, ...children);
            break;
        }
        case 3: {
            const children_2 = [error(matchValue_2.fields[0].split(""))];
            bodyHtml = react.createElement("div", {
                className: "mt-2",
            }, ...children_2);
            break;
        }
        default: {
            const loadState = matchValue_2;
            const contractBoundTo = (loadState.tag === 2) ? DateOnlyExtensions_yyyy_MM_dd(loadState.fields[0].BoundTo) : "...";
            const finalInvoiceAmountExclVat = (loadState.tag === 2) ? doubleToTwoDecimals(loadState.fields[0].FinalInvoiceAmountExclVat) : "...";
            const finalInvoiceAmountInclVat = (loadState.tag === 2) ? doubleToTwoDecimals(loadState.fields[0].FinalInvoiceAmountIncVat) : "...";
            const activePhoneNumbers = LoadState_defaultValue(empty(), LoadState_map((numbersMap) => getActivePhoneNumbers(props.ContractNr, numbersMap), props.SubscriptionListPhoneNumbers));
            const children_33 = [(children_31 = toList(delay(() => {
                let inputRecord, RadioValue, IsChecked, arg_5;
                return append(singleton(inputRadio((inputRecord = RadioInput_get_getDefault(), (RadioValue = toString_2(new TerminateContractAt(0)), (IsChecked = equals(selectedTerminateContractAtState[0], new TerminateContractAt(0)), new RadioInput("cancel-contract-radio-1", "first-radio-group", (e) => {
                    setTerminateContractAt(Browser_Types_Event__Event_get_Value(e));
                }, RadioValue, (arg_5 = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndDate"), toText(printf("%s (%s)"))(arg_5)(contractBoundTo)), IsChecked, inputRecord.Disabled)))))), delay(() => {
                    let children_4;
                    return append(singleton((children_4 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.WithBoundTo")], react.createElement("div", {
                        className: "overview__radio-sub-label",
                    }, ...children_4))), delay(() => {
                        let inputRecord_1, RadioValue_1, IsChecked_1;
                        return append(singleton(inputRadio((inputRecord_1 = RadioInput_get_getDefault(), (RadioValue_1 = toString_2(new TerminateContractAt(1)), (IsChecked_1 = equals(selectedTerminateContractAtState[0], new TerminateContractAt(1)), new RadioInput("cancel-contract-radio-2", "first-radio-group", (e_1) => {
                            setTerminateContractAt(Browser_Types_Event__Event_get_Value(e_1));
                        }, RadioValue_1, props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.InvoiceUntilDate"), IsChecked_1, inputRecord_1.Disabled)))))), delay(() => {
                            let children_6, inputRecord_2, RadioValue_2, IsChecked_2, inputRecord_3, RadioValue_3, IsChecked_3;
                            return append(singleton((children_6 = [inputRadio((inputRecord_2 = RadioInput_get_getDefault(), (RadioValue_2 = toString_2(new TerminateContractAmountRemaining(0)), (IsChecked_2 = equals(selectedTerminateContractAmountRemainingState[0], new TerminateContractAmountRemaining(0)), new RadioInput("cancel-contract-radio-3", "second-radio-group", (e_2) => {
                                setTerminateContractAmountRemaining(Browser_Types_Event__Event_get_Value(e_2));
                            }, RadioValue_2, props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.InvoiceRemainingAmount"), IsChecked_2, !equals(selectedTerminateContractAtState[0], new TerminateContractAt(1))))))), inputRadio((inputRecord_3 = RadioInput_get_getDefault(), (RadioValue_3 = toString_2(new TerminateContractAmountRemaining(1)), (IsChecked_3 = equals(selectedTerminateContractAmountRemainingState[0], new TerminateContractAmountRemaining(1)), new RadioInput("cancel-contract-radio-4", "second-radio-group", (e_3) => {
                                setTerminateContractAmountRemaining(Browser_Types_Event__Event_get_Value(e_3));
                            }, RadioValue_3, props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.GiveRemainingAmount"), IsChecked_3, !equals(selectedTerminateContractAtState[0], new TerminateContractAt(1)))))))], react.createElement("div", {
                                className: "d-flex flex-column ml-3",
                            }, ...children_6))), delay(() => {
                                let children_8, inputRecord_4, LabelText, Disabled;
                                return append(singleton((children_8 = [inputDate((inputRecord_4 = DateOptions_get_getDefault(), (LabelText = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndDate"), (Disabled = (!equals(selectedTerminateContractAtState[0], new TerminateContractAt(1))), new DateOptions(ofArray([Value_4(DateOnlyExtensions_toDateTime(selectedTerminationDateState[0])), Placeholder(props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Choose")), Id_6("cancel-contract-date"), OnChange_4((date_3) => {
                                    const dateOnly = DateOnlyExtensions_fromDateTime(date_3);
                                    selectedTerminationDateState[1](dateOnly);
                                    loadTerminateContract(dateOnly);
                                }), FormatDateBy((date_4) => DateTimeExtensions_toDate(props.Locale.ILocale, date_4)), Locale(props.Locale.FlatpickrLocale)]), LabelText, true, Disabled, inputRecord_4.OnClearClick)))))], react.createElement("div", {
                                    className: "mt-3",
                                }, ...children_8))), delay(() => {
                                    let children_22, children_10, children_20, children_14, arg_7, children_16, children_18, arg_9;
                                    return append(singleton((children_22 = [(children_10 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.SumRemainingFees")], react.createElement("p", {
                                        className: "mb-0",
                                        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.SumRemainingFees",
                                    }, ...children_10)), (children_20 = [react.createElement("span", {
                                        className: "font-weight-bold",
                                    }, finalInvoiceAmountExclVat), (children_14 = [(arg_7 = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.ExclVat"), toText(printf(" %s"))(arg_7))], react.createElement("span", {
                                        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.ExclVat",
                                    }, ...children_14)), (children_16 = [toText(printf(" (%s"))(finalInvoiceAmountInclVat)], react.createElement("span", {
                                        className: "font-weight-bold",
                                    }, ...children_16)), (children_18 = [(arg_9 = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.InclVat"), toText(printf(" %s)"))(arg_9))], react.createElement("span", {}, ...children_18))], react.createElement("p", {}, ...children_20))], react.createElement("div", {
                                        className: "mt-2 ml-2",
                                    }, ...children_22))), delay(() => {
                                        let children_29, children_25;
                                        if (isEmpty(activePhoneNumbers)) {
                                            return singleton(react.createElement(react.Fragment, {}));
                                        }
                                        else {
                                            let deactivatePhoneNumbersStr;
                                            const arg_10 = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.DeactivateNumber");
                                            deactivatePhoneNumbersStr = toText(printf("%s."))(arg_10);
                                            return singleton((children_29 = [(children_25 = [getMaterialIcon("info")], react.createElement("div", {
                                                className: "deactivate-numbers__icon",
                                            }, ...children_25)), react.createElement("div", {}, deactivatePhoneNumbersStr)], react.createElement("div", {
                                                className: "overview__deactivate-numbers mt-1",
                                            }, ...children_29)));
                                        }
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            })), react.createElement("div", {
                className: "d-flex flex-column",
            }, ...children_31))];
            bodyHtml = react.createElement("div", {
                className: "d-flex flex-column color-black",
            }, ...children_33);
        }
    }
    const cancelButtonProps = new ButtonProps(props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Cancel"), defaultProps.Content, (_arg_3) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, "cancel-contract-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const acceptButtonProps = new ButtonProps(props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TerminateSubscription"), defaultProps.Content, (_arg_4) => {
        const terminationOptions_1 = new TerminationOptions(equals(selectedTerminateContractAmountRemainingState[0], new TerminateContractAmountRemaining(1)));
        let date_1;
        const matchValue_3 = [selectedTerminateContractAtState[0], contractTerminationInfoState[0]];
        let pattern_matching_result;
        if (matchValue_3[0].tag === 0) {
            if (matchValue_3[1].tag === 2) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                date_1 = matchValue_3[1].fields[0].BoundTo;
                break;
            }
            case 1: {
                date_1 = (selectedTerminationDateState[0]);
                break;
            }
        }
        terminateContractStatusState[1](new SaveStatus(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.SaveTerminateContractFn(date_1, terminationOptions_1), (_arg_1) => {
            const result_1 = _arg_1;
            const arg_2 = (result_1.tag === 0) ? (new SaveStatus(2)) : (new SaveStatus(3, result_1.fields[0]));
            terminateContractStatusState[1](arg_2);
            return singleton_1.Zero();
        })));
    }, defaultProps.Disabled, "cancel-contract-accept-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    return renderAsModalThenSaveState(true, new ModalSize(1), props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TerminateSubscription"), bodyHtml, cancelButtonProps, acceptButtonProps, props.GetTranslation("Common.Confirm"), (_arg_5) => {
        props.ConfirmFn();
        props.CloseModalFn();
    }, singleton_2([props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TerminatingSubscription"), terminateContractStatusState[0]]));
}, "TerminateContractModal", uncurry(2, void 0), void 0, "renderTerminateContractModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\Overview.fs", 878);

function TransferredContractNotice_render(props) {
    let arg, fromContractNr, fromAtUtc, copyOfStruct, arg_2, toContractNr, toAtUtc, copyOfStruct_1, copyOfStruct_2;
    const reduxDispatch = useDispatch();
    const transferHistoryState = useSelector((state) => state.Contract.TransferHistory);
    const translationsLoadState = useSelector((state_1) => state_1.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    react.useEffect(() => {
        reduxDispatch(loadContractTransfersThunk(props.ClientNr, props.ContractNr));
    }, [props.ClientNr, props.ContractNr]);
    switch (transferHistoryState.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(transferHistoryState.fields[0].split(""));
        }
        case 2: {
            const transferHistoryOpt = transferHistoryState.fields[0];
            if (transferHistoryOpt != null) {
                const transfer = transferHistoryOpt;
                const matchValue = [transfer.FromContractNr, transfer.FromAtUtc, transfer.ToContractNr, transfer.ToAtUtc];
                let pattern_matching_result;
                if (matchValue[0] == null) {
                    if (matchValue[1] == null) {
                        if (matchValue[2] == null) {
                            if (matchValue[3] == null) {
                                pattern_matching_result = 0;
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return react.createElement(react.Fragment, {});
                    }
                    case 1: {
                        let transferIncomingFromOtherContractMessageHtml;
                        const matchValue_1 = [transfer.FromContractNr, transfer.FromAtUtc];
                        let pattern_matching_result_1, fromAtUtc_1, fromContractNr_1;
                        if (matchValue_1[0] != null) {
                            if (matchValue_1[1] != null) {
                                if ((fromContractNr = (matchValue_1[0] | 0), (fromAtUtc = matchValue_1[1], ((copyOfStruct = UTC_op_Subtraction_368FF2C0(UTCModule_now(), fromAtUtc), totalDays(copyOfStruct))) < 182.5))) {
                                    pattern_matching_result_1 = 0;
                                    fromAtUtc_1 = matchValue_1[1];
                                    fromContractNr_1 = matchValue_1[0];
                                }
                                else {
                                    pattern_matching_result_1 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                        switch (pattern_matching_result_1) {
                            case 0: {
                                transferIncomingFromOtherContractMessageHtml = info_6(((arg = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.ContractMovedFrom"), toText(printf("%s %i."))(arg)(fromContractNr_1))).split(""));
                                break;
                            }
                            case 1: {
                                transferIncomingFromOtherContractMessageHtml = react.createElement(react.Fragment, {});
                                break;
                            }
                        }
                        let transferToSomeOtherContractMessageHtml;
                        const matchValue_2 = [transfer.ToContractNr, transfer.ToAtUtc];
                        let pattern_matching_result_2, toAtUtc_1, toContractNr_1;
                        if (matchValue_2[0] != null) {
                            if (matchValue_2[1] != null) {
                                if ((toContractNr = (matchValue_2[0] | 0), (toAtUtc = matchValue_2[1], (((copyOfStruct_1 = UTC_op_Subtraction_368FF2C0(UTCModule_now(), toAtUtc), totalDays(copyOfStruct_1))) < 182.5) ? true : (((copyOfStruct_2 = UTC_op_Subtraction_368FF2C0(toAtUtc, UTCModule_now()), totalDays(copyOfStruct_2))) < 182.5)))) {
                                    pattern_matching_result_2 = 0;
                                    toAtUtc_1 = matchValue_2[1];
                                    toContractNr_1 = matchValue_2[0];
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                        switch (pattern_matching_result_2) {
                            case 0: {
                                transferToSomeOtherContractMessageHtml = info_6(((arg_2 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.ContractMovedTo"), toText(printf("%s %i."))(arg_2)(toContractNr_1))).split(""));
                                break;
                            }
                            case 1: {
                                transferToSomeOtherContractMessageHtml = react.createElement(react.Fragment, {});
                                break;
                            }
                        }
                        return react.createElement("div", {
                            id: "transferred-contract-notice",
                        }, transferToSomeOtherContractMessageHtml, transferIncomingFromOtherContractMessageHtml);
                    }
                }
            }
            else {
                return react.createElement(react.Fragment, {});
            }
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}

export const TransferredContractNotice_view = FunctionComponent_Of_Z5A158BBF(TransferredContractNotice_render, "TransferredContractNotice", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\Overview.fs", 946);

const renderDeleteSubscriptionModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, children_4, children_2, arg;
    const removeSubscriptionStr = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.DeleteContract");
    if (props.DeleteContractStatus.tag === 0) {
        let bodyHtml;
        const children_6 = [(children = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.DeleteContract.AreYouSure")], react.createElement("p", {
            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.DeleteContract.AreYouSure",
        }, ...children)), (children_4 = [(children_2 = [(arg = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Overview.DeleteContract.Restrictions"), toText(printf("(%s)"))(arg))], react.createElement("small", {
            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.DeleteContract.Restrictions",
        }, ...children_2))], react.createElement("p", {}, ...children_4))];
        bodyHtml = react.createElement("div", {}, ...children_6);
        if (props.IsOpen) {
            return renderModal(removeSubscriptionStr, bodyHtml, props.GetTranslation("Common.Cancel"), props.GetTranslation("Common.Remove"), (_arg) => {
                props.CloseModalFn();
            }, (_arg_1) => {
                props.DeleteContractFn();
            });
        }
        else {
            return react.createElement(react.Fragment, {});
        }
    }
    else {
        return render_2(true, new ModalSize(1), removeSubscriptionStr, singleton_2([removeSubscriptionStr, props.DeleteContractStatus]), props.GetTranslation("Common.Close"), (_arg_2) => {
            props.ResetStatusFn();
            props.ReloadFn();
            props.CloseModalFn();
        });
    }
}, "DeleteSubscriptionModal", uncurry(2, void 0), void 0, "renderDeleteSubscriptionModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\Overview.fs", 1020);

export class SubscriptionOverviewProps extends Record {
    constructor(Model, Dispatch, ContractNr, InvoiceeDetails) {
        super();
        this.Model = Model;
        this.Dispatch = Dispatch;
        this.ContractNr = (ContractNr | 0);
        this.InvoiceeDetails = InvoiceeDetails;
    }
}

export function SubscriptionOverviewProps$reflection() {
    return record_type("Containers.Subscriptions.Overview.SubscriptionOverviewProps", [], SubscriptionOverviewProps, () => [["Model", Model$reflection()], ["Dispatch", lambda_type(SubscriptionsMsg$reflection(), unit_type)], ["ContractNr", int32_type], ["InvoiceeDetails", InvoiceeDetails$reflection()]]);
}

export const renderSubscriptionOverview = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_7, inputRecord_1, arg_15, matchValue_10, inputRecord_3, inputRecord_2, children_23, arg_25, arg_24, arg_22, arg_21, arg_20;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const contractTypesLoadState = useSelector((state_1) => state_1.Contract.ContractTypes);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const model = props.Model;
    const dispatch = props.Dispatch;
    const contractNr = props.ContractNr | 0;
    const invoiceeDetails = props.InvoiceeDetails;
    const matchValue = model.Contracts;
    switch (matchValue.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue.fields[0].split(""));
        }
        case 2: {
            const contractOpt = tryFind_1((contract) => (contract.ContractNumber === contractNr), matchValue.fields[0]);
            if (contractOpt != null) {
                const contract_1 = contractOpt;
                const locale = Locale_get_FromSelectedLanguage()(model.GlobalDependencies.SelectedLanguage);
                const terminateContractModalHtml = (model.OpenModal.tag === 2) ? renderTerminateContractModal(new TerminateContractModalProps(props.ContractNr, model.SubscriptionListPhoneNumbers, getTranslation, locale, (terminationAtDate) => loadTerminateContract_1(model.GlobalDependencies.ClientNr, props.ContractNr, terminationAtDate), (date, terminationOptions) => saveTerminateContract_1(model.GlobalDependencies.ClientNr, props.ContractNr, date, terminationOptions), () => {
                    dispatch(new SubscriptionsMsg(24, props.ContractNr, Cmd_OfFunc_result(new SubscriptionsMsg(39, new Intent(1)))));
                }, () => {
                    dispatch(new SubscriptionsMsg(10, new Modal(0)));
                })) : react.createElement(react.Fragment, {});
                const transferContractViewHistoryModalHtml = modal(equals(model.OpenModal, new Modal(3)), renderTransferContractWithHistory({
                    ClientNr: model.GlobalDependencies.ClientNr,
                    CloseModal: () => {
                        dispatch(new SubscriptionsMsg(10, new Modal(0)));
                    },
                    ContractNr: contractNr,
                    Locale: locale,
                }));
                let changeContractTypeButtonHtml;
                let pattern_matching_result, contractTypes_1;
                if (contractTypesLoadState.tag === 2) {
                    if (count(contractTypesLoadState.fields[0]) > 1) {
                        pattern_matching_result = 0;
                        contractTypes_1 = contractTypesLoadState.fields[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        const children_1 = [wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType"), defaultProps.Content, (_arg) => {
                            dispatch(new SubscriptionsMsg(10, new Modal(4)));
                        }, defaultProps.Disabled, "change-contract-type-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modal(equals(model.OpenModal, new Modal(4)), view(new ChangeContractModalProps(model.GlobalDependencies, contractNr, contractTypes_1, () => {
                            dispatch(new SubscriptionsMsg(10, new Modal(0)));
                        }, () => {
                            dispatch(new SubscriptionsMsg(22, contractNr));
                            reduxDispatch(loadContractsThunk(model.GlobalDependencies.ClientNr, invoiceeDetails.InvoiceeNr));
                        })))];
                        changeContractTypeButtonHtml = react.createElement(react.Fragment, {}, ...children_1);
                        break;
                    }
                    case 1: {
                        changeContractTypeButtonHtml = react.createElement(react.Fragment, {});
                        break;
                    }
                }
                const contractInfoHtml = renderContractInfo(new RenderContractInfoProps(getTranslation, model.GlobalDependencies.ClientNr, contract_1, (infoTableVM) => {
                    let tupledArg;
                    props.Dispatch((tupledArg = [infoTableVM, contract_1], new SubscriptionsMsg(18, tupledArg[0], tupledArg[1])));
                }, model.ClientObjectCodes, locale, model.GlobalDependencies.ClientConfig.UsesSubscriptionObjectCode, model.GlobalDependencies.ClientConfig.ShowCrossReference, model.GlobalDependencies.ClientConfig.IsTelecom, model.GlobalDependencies.ClientConfig.ShowSubscriptionDescription, model.GlobalDependencies.ClientConfig.UsesContractEndUserTable));
                let comingContractTypeChangeMsgHtml;
                const matchValue_2 = model.ComingContractTypeChange;
                let pattern_matching_result_1, contractTypeChange;
                if (matchValue_2.tag === 1) {
                    pattern_matching_result_1 = 0;
                }
                else if (matchValue_2.tag === 2) {
                    if (matchValue_2.fields[0] != null) {
                        pattern_matching_result_1 = 1;
                        contractTypeChange = matchValue_2.fields[0];
                    }
                    else {
                        pattern_matching_result_1 = 2;
                    }
                }
                else {
                    pattern_matching_result_1 = 2;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        comingContractTypeChangeMsgHtml = dotsLoading;
                        break;
                    }
                    case 1: {
                        let contractTypeChangeMsg;
                        const dateStr = DateTimeOffsetExtensions_toDate(locale.ILocale, toLocalTime(contractTypeChange.StartDate));
                        const arg_9 = getTranslation("Common.To").toLocaleLowerCase();
                        const arg_7 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.PlannedContractTypeChange");
                        contractTypeChangeMsg = toText(printf("%s %s %s %s."))(arg_7)(dateStr)(arg_9)(contractTypeChange.Display);
                        let goToHistoryMsg;
                        const arg_11 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.GoToPlannedChanges");
                        goToHistoryMsg = toText(printf(" %s. "))(arg_11);
                        const historyLink = RouterModule_encodeParts(formatUrl(RouterModule_urlSegments(window.location.hash, 1), ofArray(["Subscriptions", int32ToString(contractNr)]), singleton_2("History")), 1);
                        comingContractTypeChangeMsgHtml = customMessage((children_7 = [react.createElement("span", {}, contractTypeChangeMsg), react.createElement("a", {
                            href: historyLink,
                        }, goToHistoryMsg)], react.createElement("span", {}, ...children_7)), new MessageKind(0));
                        break;
                    }
                    case 2: {
                        comingContractTypeChangeMsgHtml = react.createElement(react.Fragment, {});
                        break;
                    }
                }
                let createDocumentButtonHtml;
                const matchValue_3 = model.CurrentSubscriptionContractNr;
                createDocumentButtonHtml = ((matchValue_3 != null) ? view_1(new DownloadPDFModelProps(model.GlobalDependencies.ClientNr, invoiceeDetails.InvoiceeNr, matchValue_3)) : react.createElement(react.Fragment, {}));
                let createDocumentAndSignModalHtml;
                const matchValue_4 = [model.CurrentSubscriptionContractNr, model.GlobalDependencies.ClientConfig.DocumentSigningEnabled];
                let pattern_matching_result_2, contractNr_3;
                if (matchValue_4[0] != null) {
                    if (matchValue_4[1]) {
                        pattern_matching_result_2 = 0;
                        contractNr_3 = matchValue_4[0];
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                }
                else {
                    pattern_matching_result_2 = 1;
                }
                switch (pattern_matching_result_2) {
                    case 0: {
                        createDocumentAndSignModalHtml = view_2(new DownLoadAndSignProps(model.GlobalDependencies.ClientNr, contractNr_3, invoiceeDetails));
                        break;
                    }
                    case 1: {
                        createDocumentAndSignModalHtml = react.createElement(react.Fragment, {});
                        break;
                    }
                }
                const deleteSubscriptionModalHtml = (model.OpenModal.tag === 5) ? renderDeleteSubscriptionModal({
                    CloseModalFn: () => {
                        dispatch(new SubscriptionsMsg(10, new Modal(0)));
                    },
                    DeleteContractFn: () => {
                        dispatch(new SubscriptionsMsg(26));
                    },
                    DeleteContractStatus: model.DeleteContractStatus,
                    GetTranslation: getTranslation,
                    IsOpen: equals(model.OpenModal, new Modal(5)),
                    ReloadFn: () => {
                        dispatch(new SubscriptionsMsg(2));
                    },
                    ResetStatusFn: () => {
                        dispatch(new SubscriptionsMsg(28));
                    },
                }) : react.createElement(react.Fragment, {});
                let dropdownButtonHtml;
                const terminateContractProps = new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TerminateSubscription"), defaultProps.Content, (_arg_1) => {
                    dispatch(new SubscriptionsMsg(10, new Modal(2)));
                }, defaultProps.Disabled, "terminate-subscription-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
                const transferContractNewProps = new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.TransferContractNew"), defaultProps.Content, (_arg_2) => {
                    dispatch(new SubscriptionsMsg(10, new Modal(3)));
                }, defaultProps.Disabled, "transfer-contract-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
                let deleteSubscriptionProps;
                const inputRecord = ButtonProps_get_getDefault();
                deleteSubscriptionProps = (new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.DeleteContract"), inputRecord.Content, (_arg_3) => {
                    dispatch(new SubscriptionsMsg(10, new Modal(5)));
                }, inputRecord.Disabled, "delete-contract-btn", inputRecord.SaveStatus, inputRecord.HTMLProps, inputRecord.ExtraClasses, inputRecord.Icon));
                dropdownButtonHtml = dropDownButton((inputRecord_1 = DropDownButtonProps_get_GetDefault(), new DropDownButtonProps("subscription-more-actions-btn", (arg_15 = getTranslation("Common.MoreActions"), toText(printf("%s"))(arg_15)), ofArray([transferContractNewProps, terminateContractProps, deleteSubscriptionProps]))));
                const currentProductType = map((ct) => ProductModule_ofInt(ct.ProductNr), Model__GetCurrentContractType_789D039B(model, contractTypesLoadState));
                let patternInput;
                if (currentProductType != null) {
                    const product = currentProductType;
                    patternInput = [equals(product, new Product(0)), equals(product, new Product(3))];
                }
                else {
                    patternInput = [false, false];
                }
                const activePhoneNumbers = LoadState_defaultValue(empty(), LoadState_map((numbersMap) => getActivePhoneNumbers(props.ContractNr, numbersMap), props.Model.SubscriptionListPhoneNumbers));
                let simpleOrderHtml;
                const matchValue_6 = patternInput[0] ? true : patternInput[1];
                simpleOrderHtml = (matchValue_6 ? renderSimpleOrder(new SimpleOrderProps(model.GlobalDependencies, contract_1.ContractNumber, currentProductType, Model_GetCurrentNetworkContractNr(model, contractTypesLoadState), () => {
                    dispatch(new SubscriptionsMsg(2));
                }, activePhoneNumbers)) : react.createElement(react.Fragment, {}));
                let feesSectionHtml;
                const matchValue_7 = Model__GetCurrentContractType_789D039B(model, contractTypesLoadState);
                if (matchValue_7 != null) {
                    const contractType = matchValue_7;
                    const matchValue_8 = tryFind(contract_1.ContractNumber, model.Fees);
                    feesSectionHtml = ((matchValue_8 != null) ? renderFeesSection(new FeesProps(matchValue_8, () => {
                        dispatch(new SubscriptionsMsg(6, contract_1.ContractNumber));
                    }, model.GlobalDependencies, contract_1.ContractNumber, contractType.ContractTypeCode, contractType.ProductNr, model.PaymentMethod, false, BillingIntervalModule_toInt(model.InvoiceeDetails.MonthlyBillingInterval), false, () => {
                        dispatch(new SubscriptionsMsg(24, contract_1.ContractNumber, Cmd_OfFunc_result(new SubscriptionsMsg(39, new Intent(1)))));
                    })) : react.createElement(react.Fragment, {}));
                }
                else {
                    feesSectionHtml = react.createElement(react.Fragment, {});
                }
                let createFeeButtonHtml;
                const matchValue_9 = [Model__GetCurrentContractType_789D039B(model, contractTypesLoadState), model.FeeTemplates, model.ChartOfAccounts];
                let pattern_matching_result_3, chartOfAccounts, contractType_1, feeTemplates;
                if (matchValue_9[0] != null) {
                    if (matchValue_9[1].tag === 2) {
                        if (matchValue_9[2].tag === 2) {
                            pattern_matching_result_3 = 0;
                            chartOfAccounts = matchValue_9[2].fields[0];
                            contractType_1 = matchValue_9[0];
                            feeTemplates = matchValue_9[1].fields[0];
                        }
                        else {
                            pattern_matching_result_3 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_3 = 1;
                    }
                }
                else {
                    pattern_matching_result_3 = 1;
                }
                switch (pattern_matching_result_3) {
                    case 0: {
                        createFeeButtonHtml = renderCreateFeeButton(new CreateFeeProps(feeTemplates, chartOfAccounts, model.GlobalDependencies.ClientConfig.UseAccountNo, BillingIntervalModule_toInt(invoiceeDetails.MonthlyBillingInterval), contractType_1.ContractTypeCode, contractType_1.ProductNr, Locale_get_FromSelectedLanguage()(model.GlobalDependencies.SelectedLanguage), model.GlobalDependencies.CountryCode, model.PaymentMethod, (matchValue_10 = model.MaxFee, (matchValue_10.tag === 2) ? matchValue_10.fields[0].FeeMax : (void 0)), (vm) => {
                            dispatch(new SubscriptionsMsg(37, vm));
                            dispatch(new SubscriptionsMsg(24, contract_1.ContractNumber, Cmd_batch(ofArray([Cmd_OfFunc_result(new SubscriptionsMsg(39, new Intent(1))), Cmd_OfFunc_result(new SubscriptionsMsg(6, contractNr))]))));
                        }, model.GlobalDependencies.ClientConfig.EnableFeesV2 ? (new FeeVersion(1, (inputRecord_3 = model.GlobalDependencies.ClientConfig.FeeConfig, new FeeConfig(inputRecord_3.OneTime, inputRecord_3.Monthly, inputRecord_3.MonthlyDate, inputRecord_3.MonthlyWith3MonthsInvoice, inputRecord_3.MonthlyWith6MonthsInvoice, inputRecord_3.MonthlyWith12MonthsInvoice, inputRecord_3.QuarterlyDate, inputRecord_3.HalfYearDate, inputRecord_3.YearlyDate, false, inputRecord_3.DefaultMonthsInAdvance, inputRecord_3.DefaultCancellationPeriodMonths, inputRecord_3.UsesUnitPrice)))) : (new FeeVersion(0, (inputRecord_2 = model.GlobalDependencies.ClientConfig.FeeConfig, new FeeConfig(inputRecord_2.OneTime, inputRecord_2.Monthly, inputRecord_2.MonthlyDate, inputRecord_2.MonthlyWith3MonthsInvoice, inputRecord_2.MonthlyWith6MonthsInvoice, inputRecord_2.MonthlyWith12MonthsInvoice, inputRecord_2.QuarterlyDate, inputRecord_2.HalfYearDate, inputRecord_2.YearlyDate, false, inputRecord_2.DefaultMonthsInAdvance, inputRecord_2.DefaultCancellationPeriodMonths, inputRecord_2.UsesUnitPrice)))), new FeeType(0), model.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice));
                        break;
                    }
                    case 1: {
                        createFeeButtonHtml = react.createElement(react.Fragment, {});
                        break;
                    }
                }
                let billingInfoTableHtml;
                const matchValue_12 = model.BillingInfo;
                switch (matchValue_12.tag) {
                    case 1: {
                        billingInfoTableHtml = dotsLoading;
                        break;
                    }
                    case 3: {
                        billingInfoTableHtml = error(matchValue_12.fields[0].split(""));
                        break;
                    }
                    case 2: {
                        const billingInfoOpt = matchValue_12.fields[0];
                        billingInfoTableHtml = ((billingInfoOpt != null) ? renderBillingInfoTable(new BillingInfoProps(model.GlobalDependencies, billingInfoOpt, locale, model.PaymentMethod, () => {
                            dispatch(new SubscriptionsMsg(29, contractNr));
                        }, (dto) => saveBillingInfo(model.GlobalDependencies.ClientNr, contractNr, dto))) : info_6(getTranslation("CustomerContract.Invoicee.Subscriptions.Other.NoInvoiceInformation").split("")));
                        break;
                    }
                    default: {
                        billingInfoTableHtml = react.createElement(react.Fragment, {});
                    }
                }
                const endUserTable = model.GlobalDependencies.ClientConfig.UsesContractEndUserTable ? renderEndUserTable(new EndUserTableProps(model.GlobalDependencies, contractNr)) : react.createElement(react.Fragment, {});
                const children_25 = [TransferredContractNotice_view({
                    ClientNr: model.GlobalDependencies.ClientNr,
                    ContractNr: contractNr,
                }), comingContractTypeChangeMsgHtml, react.createElement("div", {
                    className: "overview__container",
                }, createDocumentButtonHtml, createDocumentAndSignModalHtml, createFeeButtonHtml, changeContractTypeButtonHtml, dropdownButtonHtml), feesSectionHtml, simpleOrderHtml, react.createElement("div", {
                    className: "overview__container",
                }, contractInfoHtml, billingInfoTableHtml, endUserTable), (children_23 = [(arg_25 = DateTimeExtensions_toDate(locale.ILocale, contract_1.UpdatedTime), (arg_24 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.CreatedChanged"), (arg_22 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.CreatedBy"), (arg_21 = DateTimeExtensions_toDate(locale.ILocale, contract_1.CreatedTime), (arg_20 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Created"), toText(printf("%s: %s %s %s. %s: %s."))(arg_20)(arg_21)(arg_22)(contract_1.CreatedBy)(arg_24)(arg_25))))))], react.createElement("p", {
                    className: "overview__last-changed",
                }, ...children_23)), terminateContractModalHtml, transferContractViewHistoryModalHtml, deleteSubscriptionModalHtml];
                return react.createElement("div", {
                    className: "subscriptions__overview",
                }, ...children_25);
            }
            else {
                let msg_1;
                const arg = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.CouldNotFindContract");
                msg_1 = toText(printf("%s %i."))(arg)(contractNr);
                return error(msg_1.split(""));
            }
        }
        default: {
            return info_6(getTranslation("Common.WaitingToLoad").split(""));
        }
    }
}, "SubscriptionOverview", uncurry(2, void 0), void 0, "renderSubscriptionOverview", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\Overview.fs", 1405);

